<template>
  <div>
    <v-container>
        <v-row>
            <v-col cols="12" sm="3">
                <v-card tile>
                  <v-card-text class="pa-1">
                   
                      <table class="va-table">
                          <tr>
                              <td class="text-center bg-success"> <v-icon center x-large color="white">mdi-currency-php</v-icon></td>
                              <td class="text-center pa-2">
                                  <span class="text-h6 font-weight-bold">{{$money(TODAYSALES)}}</span>
                                  <v-divider />
                                  <span class="def-font text-success "> TODAY'S SALES</span>
                              </td>
                          </tr>
                      </table>
                    </v-card-text>
                </v-card>
            </v-col>
             <v-col cols="12" sm="3">
                <v-card tile>
                  <v-card-text class="pa-1">
                   
                      <table class="va-table">
                          <tr>
                              <td class="text-center bg-info"> <v-icon center x-large color="white">mdi-file-cog</v-icon></td>
                              <td class="text-center pa-2">
                                  <span class="text-h6 font-weight-bold">{{$count(item_costs.length)}}</span>
                                  <v-divider />
                                  <span class="def-font text-info ">SOLD PRODUCTS</span>
                              </td>
                          </tr>
                      </table>
                    </v-card-text>
                </v-card>
            </v-col>
             <v-col cols="12" sm="3">
                <v-card tile>
                  <v-card-text class="pa-1">
                   
                      <table class="va-table">
                          <tr>
                              <td class="text-center bg-indigo"> <v-icon center x-large color="white">mdi-account-file</v-icon></td>
                              <td class="text-center pa-2">
                                  <span class="text-h6 font-weight-bold">{{$count(8)}}</span>
                                  <v-divider />
                                  <span class="def-font text-indigo ">NEW CUSTOMER </span>
                              </td>
                          </tr>
                      </table>
                    </v-card-text>
                </v-card>
            </v-col>
             <v-col cols="12" sm="3">
                <v-card tile>
                  <v-card-text class="pa-1">
                   
                      <table class="va-table">
                          <tr>
                              <td class="text-center bg-error"> <v-icon center x-large color="white">mdi-archive-eye</v-icon></td>
                              <td class="text-center  pa-2">
                                  <span class="text-h6 font-weight-bold">{{$money(85002)}}</span>
                                  <v-divider />
                                  <span class="def-font text-error ">INVENTORY GROSS</span>
                              </td>
                          </tr>
                      </table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
               <v-col cols="12" sm="8">
                    <v-card tile>
                       <v-card-text>
                          <span class="font-weight-bold">30 Days Sales Performance</span>
                          <v-divider />
                          <div>
                               <chart-gross :rawdata="SALESDATA" :show="chart"/>

                          </div>
                         </v-card-text> 
                    </v-card>
                    
               </v-col>
               <v-col cols="12" sm="4">
                     <v-card tile>
                       <v-card-text>
                          <span class="font-weight-bold">Sales by Payment Method</span>
                          <v-divider />
                          <chart-payments :rawdata="payment_methods" :show="pie"/>
                         </v-card-text> 
                    </v-card>
               </v-col>
        </v-row>

        <v-row>
               <v-col cols="12" sm="7">
                    <v-card tile>
                       <v-card-text>
                          <span class="font-weight-bold">Recent Transaction</span>
                          <v-divider />
                             <table class="va-table va-table-border-bot">
                                <tr v-for="(item, index) in transactions" :key="index+'-t'">
                                 <td > 
                                   <span class="font-weight-bold">{{item.id}}</span> 
                                    <br />
                                    <span class="font-italic def-font">{{item.customer_data.fullname}}</span>
                                </td>
                                <td class="text-info font-italic def-font"> {{$moment(item.created_at).fromNow()}}</td>
                                
                                <td> <v-chip small :color="STATUS_COLOR(item.status)">{{item.status}}</v-chip></td>
                                <td class="text-right">{{$money(item.total_amount)}}</td>
                                </tr>
                             </table>

                         </v-card-text> 
                    </v-card>
                    
               </v-col>
               <v-col cols="12" sm="5">
                     <v-card tile>
                       <v-card-text>
                          <span class="font-weight-bold">Today's Summary</span>
                          <v-divider />
                              <table class="va-table va-table-border-bot">
                                <tr>
                                  <td class="text-success"><v-icon left color="success">mdi-currency-php</v-icon>Total Sales</td>
                                  <td class="text-success text-right font-weight-bold">{{ $money(TODAYSALES) }}</td>
                                </tr>
                                 <tr>
                                  <td class="text-info"> <v-icon left color="info">mdi-cash-multiple</v-icon> Total Cost</td>
                                  <td class="text-info text-right font-weight-bold">{{ $money(TODAYSCOST) }}</td>
                                </tr>
                                <tr>
                                  <td><v-icon left>mdi-bank-transfer-in</v-icon> Gross Profit</td>
                                  <td class="text-right font-weight-bold">{{ $money(TODAYSALES - TODAYSCOST) }}</td>
                                </tr>
                                <tr>
                                  <td class="text-warning"><v-icon left color="warning">mdi-currency-php-off</v-icon> Expenses</td>
                                  <td class="text-warning text-right font-weight-bold">{{ $money(TODAYEXPENPESE) }}</td>
                                </tr>
                                <tr>
                                  <td class="text-primary text-h6"><v-icon left color="primary">mdi-piggy-bank</v-icon>Net Profit</td>
                                  <td class="text-primary text-h6 text-right font-weight-bold">{{ $money(TODAYSALES - TODAYSCOST - TODAYEXPENPESE) }}</td>
                                </tr>
                              </table>
                         </v-card-text> 
                    </v-card>
               </v-col>
        </v-row>

    </v-container>
   </div>
 </template>
 <script>

 import {
   mapMutations
 } from 'vuex'
   export default {
     data: () => ({
      chart: false,
      pie: false,
      allowed_files:'',
      transactions:[],
      uploadedfiles:[],
      imagePreviews: [],
      expenses:[],
      upload_status:'',
      payment_methods:[],
      sales: [],
      item_costs:[],
      today_sales:[],
      location: 'end',
      items: ["Test 1", "Test 2", "Test 3", "Test 4", "Test 5"]
     }),
     beforeCreate: function () {
       if (!this.$session.exists()) {
         this.$router.push('/')
       } 
     },
     created() {
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
        this.setLoggedIn(true) 
        this.SETVARS()
        this.getRecent()
        this.getPaymentMethods()
       this.getSales()
       this.getTodaySales()
       this.getExpenses()
       this.getItemCosts()

     },
     computed:{
      TODAYEXPENPESE(){
        var total = this.expenses.reduce((res,item)=>{
              res = this.$IsNum(res) +  this.$IsNum(item.amount)
              return res
        }, 0)
        return total
      },
      TODAYSALES(){
        var total = this.today_sales.reduce((res,item)=>{
              res = this.$IsNum(res) +  this.$IsNum(item.amount)
              return res
        }, 0)
        return total
      },
      TODAYSCOST(){
        var total = this.item_costs.reduce((res,item)=>{
              res = this.$IsNum(res) +  this.$IsNum(item.cost)
              return res
        }, 0)
        return total
      },
        SALESDATA(){
            return this.sales
        }
     },
     methods: {
       ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
     getItemCosts() { 
           this.item_costs = []
            this.QUERY('sales',`select i.* from sales_items i left join sales s on s.id=i.sales_id
where s.payment_status = 'Paid' and s.status='Completed'  and to_date(s.created_at::text,'YYYY-MM-DD')=to_date(CURRENT_DATE::text,'YYYY-MM-DD')`, (res)=>{
              this.item_costs = res.results
                
            })
        }, 
          getExpenses() { 
           this.expenses = []
            this.QUERY('sales',`select date, sum(amount) as amount from expenses where date=TO_CHAR(CURRENT_DATE,'YYYY-MM-DD') group by date`, (res)=>{
              this.expenses = res.results
                
            })
        }, 
        getTodaySales() { 
           this.today_sales = []
            this.QUERY('sales',`select to_date(created_at::text,'YYYY-MM-DD') as sales_date, total_amount as amount from sales 
where payment_status = 'Paid' and status='Completed'  and to_date(created_at::text,'YYYY-MM-DD')=to_date(CURRENT_DATE::text,'YYYY-MM-DD')`, (res)=>{
              this.today_sales = res.results
            })
        }, 
         getSales() { 
           this.sales = []
            this.QUERY('sales',`select to_date(created_at::text,'YYYY-MM-DD') as sales_date, sum(total_amount) as amount from sales where payment_status = 'Paid' and status='Completed' 
group by to_date(created_at::text,'YYYY-MM-DD') order by sales_date limit 30`, (res)=>{
              this.sales = res.results
              console.log(this.sales)
                 setTimeout(()=>{
                this.chart = true
                },1000)
            })
        }, 
          getRecent() { 
           this.transactions = []
            this.QUERY('sales','select id, customer_data, created_at, status, type, invoice_no, total_amount, payment_status,discount_request  from sales order by id desc limit 10', (res)=>{
              this.transactions = res.results
              
            })
        },
        getPaymentMethods() { 
           this.payment_methods = []
            this.QUERY('sales',`select coalesce(payment_method, 'Others') as method, sum(total_amount) as amount from sales where payment_status = 'Paid' 
group by payment_method`, (res)=>{
              this.payment_methods = res.results
              setTimeout(()=>{
                this.pie = true
                },1000)
            })
        }
     },
   }
 </script>